// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"f21e481a","3728":"f21e481a","4353":"adeaeb8a"}[chunkId] + ".chunk.css";
};